import { render, staticRenderFns } from "./normas-collapse.vue?vue&type=template&id=215bd524&scoped=true"
import script from "./normas-collapse.vue?vue&type=script&lang=js"
export * from "./normas-collapse.vue?vue&type=script&lang=js"
import style0 from "./normas-collapse.vue?vue&type=style&index=0&id=215bd524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215bd524",
  null
  
)

export default component.exports